import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import cx from 'classnames';
import './App.scss';
import Questions from './components/questions.js';
import Result from './components/result.js';
import DebugPanel from './components/debug-panel.js';


function App() {
  const isLoaded = useSelector( s => s.isLoaded );
  const hasAtLeastOneSelection = useSelector( s => s.questions.find( q => {
      if ( q.type === 'radio-grid' ){
        return q.selection !== null
      } else {
        return q.selection.length > 0
      }
  }) );
  const url = new URL( window.location );
  return (
    <div className={ cx(
      "service-recommender",
      isLoaded ? 'is-loaded' : false,
      !hasAtLeastOneSelection ? 'has-no-selections' : false
    ) } >
      <div className="inner-container">
      { !isLoaded &&
        <div className="loading-message">
          Loading...
        </div>
      }
      { isLoaded &&
        <React.Fragment>
          <div className="sr-left">
            <Questions />
            { url.searchParams.has('debug') &&
              <DebugPanel />
            }
          </div>
          <div className="sr-right">
            <Result />
          </div>
        </React.Fragment>
      }
      </div>
    </div>
  );
}

export default App;
